<div class="px-20 py-20">
  <h2 class="mb-6">Headings</h2>
  <h1>Heading 1</h1>
  <h2>Heading 2</h2>
  <h3>Heading 3</h3>
  <h4>Heading 4</h4>
  <h5>Heading 5</h5>
</div>

<hr />
<div class="px-20 py-20">
  <h2 class="mb-6">Colors</h2>
  <span class="text-navy mr-5">&#x02588; Navy</span>
  <span class="text-darkGreyBlue mr-5">&#x02588; Dark Grey Blue</span>
  <span class="text-metallicBlue mr-5">&#x02588; Metallic Blue</span>
  <span class="text-gold mr-5">&#x02588; Gold</span>
  <span class="text-goldTwo mr-5">&#x02588; Gold Two</span>
  <span class="text-charcoal mr-5">&#x02588; Charcoal</span>
  <span class="text-grey mr-5">&#x02588; Grey</span>
  <span class="text-medGrey mr-5">&#x02588; Medium Grey</span>
  <span class="text-ltGrey mr-5">&#x02588; Light Grey</span>
  <span class="text-veryLtGrey mr-5">&#x02588; Very Light Grey</span>
  <span class="text-offWhite mr-5">&#x02588; Off White</span>
  <span class="text-black mr-5">&#x02588; Black</span>
  <span class="text-blue mr-5">&#x02588; Blue</span>
  <span class="text-blueTwo mr-5">&#x02588; Blue Two</span>
  <span class="text-viridian mr-5">&#x02588; Viridian</span>
  <span class="text-sienna mr-5">&#x02588; Sienna</span>
  <span class="text-veryLightPink mr-5">&#x02588; Very Light Pink</span>
  <span class="text-chablis">&#x02588; Chablis</span>

  <div class="mt-15">
    <span class="bg-navy text-white p-10 mr-5"> Navy</span>
    <span class="bg-darkGreyBlue text-white p-10 mr-5"> Dark Grey Blue</span>
    <span class="bg-metallicBlue text-white p-10 mr-5"> Metallic Blue</span>
    <span class="bg-gold p-10 mr-5"> Gold</span>
    <span class="bg-goldTwo p-10 mr-5"> Gold Two</span>
    <span class="bg-charcoal text-white p-10 mr-5"> Charcoal</span>
    <span class="bg-grey text-white p-10 mr-5"> Grey</span>
    <span class="bg-medGrey p-10 mr-5"> Medium Grey</span>
    <span class="bg-ltGrey p-10 mr-5"> Light Grey</span>
    <span class="bg-veryLtGrey p-10 mr-5"> Very Light Grey</span>
    <span class="bg-offWhite p-10 mr-5"> Off White</span>
    <span class="bg-white text-black p-10 mr-5"> White</span>
    <span class="bg-black text-white p-10 mr-5"> Black</span>
    <span class="bg-blue p-10 mr-5"> Blue</span>
    <span class="bg-blueTwo p-10 mr-5"> Blue Two</span>
    <span class="bg-viridian p-10 mr-5"> Viridian</span>
    <span class="bg-sienna p-10 mr-5"> Sienna</span>
    <span class="bg-veryLightPink p-10 mr-5"> Very Light Pink</span>
    <span class="bg-chablis p-10"> Chablis</span>
  </div>
</div>

<hr />
<div class="px-20 py-20">
  <h2 class="mb-6">Buttons</h2>
  <div class="flex mb-20">
    <button class="btn mr-10">Button</button>
    <button class="btn btn-wide mr-10">Wide button</button>
    <button class="btn btn-lg mr-10">Large button</button>
    <button class="btn btn-xl">Extra Large</button>
  </div>

  <div class="flex mb-20">
    <button class="btn btn-grey mr-10">Button</button>
    <button class="btn btn-grey btn-lg">Large button</button>
  </div>
  <button class="btn btn-disabled mr-10">Disabled</button>
  <button class="btn btn-disabled btn-xl">Extra Disabled</button>
  <br />
  <br />
  <button class="btn">
    <svg-icon src="assets/images/svg/icons/misc/edit.svg"></svg-icon>
    Icon Button
  </button>
  <br />
  <br />
  <button class="btn btn-badge">
    Badge
    <span>2</span>
  </button>
  <br />
  <br />
  <button class="btn btn-text">
    <svg-icon src="assets/images/svg/icons/misc/edit.svg"></svg-icon>
    Edit
  </button>
  <button class="btn btn-text">Games</button>
  <br />
  <br />
  <button class="btn btn-filter">
    Filter button
    <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
  </button>
  <br />
  <br />
  <button class="btn btn-icon">
    <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
  </button>
  <button class="btn btn-lg btn-icon ml-10">
    <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
  </button>
  <button class="btn btn-circle btn-yellow ml-10">
    <svg-icon src="assets/images/svg/rebrand/edit-profile.svg"></svg-icon>
  </button>
</div>

<hr />
<div class="px-20 py-20">
  <h2 class="mb-6">Inputs</h2>
  <label for="input1" class="input-title">Athlete Name</label>
  <div class="input input-text">
    <input id="input1" type="text" placeholder="Alex Horowitz" />
  </div>
  <br />
  <label for="input2" class="input-title required">Athlete Name</label>
  <div class="input input-text">
    <input id="input2" type="text" placeholder="Alex Horowitz" />
    <div>Not Available</div>
  </div>
  <br />
  <div class="input input-text">
    <div><svg-icon src="assets/images/svg/rebrand/search.svg"></svg-icon></div>
    <input id="input2" type="text" placeholder="Alex Horowitz" />
  </div>
  <br />
  <label for="input2" class="input-title">Error Name</label>
  <div class="input input-text input-error">
    <input id="input2" type="text" />
  </div>
  <br />
  <div class="input input-text input-lg">
    <input id="input3" type="text" placeholder="Username" />
    <div class="text-viridian">Available</div>
  </div>
  <br />
  <label for="input4" class="input-title required">Comment</label>
  <div class="input input-text">
    <input id="input4" type="text" placeholder="Enter message..." />
    <div>
      <button class="btn btn-text">Add Note</button>
    </div>
  </div>
  <br />
  <div class="input input-textarea">
    <textarea placeholder="This is a textarea..."></textarea>
  </div>
  <br />
  <div class="p-10 bg-viridian">
    <div class="input input-text input-no-border">
      <input id="input5" type="text" placeholder="Placeholder" />
    </div>
  </div>
  <br />
  <div class="input input-radio">
    <label>
      <input type="radio" value="1" id="radio1" name="radio" />
      <span class="selector"></span>
      <span class="label" for="radio1">Male</span>
    </label>
  </div>
  <div class="input input-radio">
    <label>
      <input type="radio" value="false" id="radio2" name="radio" />
      <span class="selector"></span>
      <span class="label" for="radio2">Female</span>
    </label>
  </div>
  <br />
  <br />
  <div>
    <div class="input input-checkbox">
      <label>
        <input type="checkbox" tabIndex="1" />
        <span class="selector"></span>
        <span class="label">One</span>
      </label>
    </div>

    <div class="input input-checkbox input-filled">
      <label>
        <input type="checkbox" tabIndex="2" checked="true" />
        <span class="selector"></span>
        <span class="label">Another</span>
      </label>
    </div>
  </div>
</div>

<section class="px-20 py-20">
  <h2 class="mb-6">Dropdowns</h2>
  <div class="flex align-center">
    <div>
      <label class="inline-block text-charcoal mb-5">Dropdown label</label>
      <ng-select
        [items]="['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5']"
        placeholder="Placeholder test"
        [clearable]="true"
        [searchable]="false"
        class="inline-block"
        style="min-width: 250px"
      >
      </ng-select>
    </div>
    <div>
      <ng-select
        [items]="[
          { value: 2, name: 'Most Recent', icon: 'assets/images/svg/icons/misc/clock.svg' },
          { value: 3, name: 'Title', icon: 'assets/images/svg/icons/misc/az.svg' },
          { value: 4, name: 'Most Views', icon: 'assets/images/svg/icons/misc/eye.svg' }
        ]"
        bindLabel="name"
        bindValue="value"
        placeholder="Placeholder text"
        [clearable]="false"
        [searchable]="false"
        class="small"
        style="min-width: 150px"
      >
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="flex align-center">
            <svg-icon [src]="item.icon"></svg-icon>
            <div class="ml-5">{{ item.name }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</section>

<div class="px-20 py-20">
  <h2 class="mb-6">Layout</h2>
  <section>
    <div class="flex">
      <div class="p-10 mx-5 bg-ltGrey">1</div>
      <div class="p-10 mx-5 bg-ltGrey">2</div>
      <div class="p-10 mx-5 bg-ltGrey">3</div>
    </div>
    <div class="flex justify-center mt-10">
      <div class="p-10 mx-5 bg-ltGrey">1</div>
      <div class="p-10 mx-5 bg-ltGrey">2</div>
      <div class="p-10 mx-5 bg-ltGrey">3</div>
    </div>
    <div class="flex justify-end mt-10">
      <div class="p-10 mx-5 bg-ltGrey">1</div>
      <div class="p-10 mx-5 bg-ltGrey">2</div>
      <div class="p-10 mx-5 bg-ltGrey">3</div>
    </div>
    <div class="flex justify-between mt-10">
      <div class="p-10 mx-5 bg-ltGrey">1</div>
      <div class="p-10 mx-5 bg-ltGrey">2</div>
      <div class="p-10 mx-5 bg-ltGrey">3</div>
    </div>
    <div class="flex justify-around mt-10">
      <div class="p-10 mx-5 bg-ltGrey">1</div>
      <div class="p-10 mx-5 bg-ltGrey">2</div>
      <div class="p-10 mx-5 bg-ltGrey">3</div>
    </div>
  </section>
  <section class="mt-10">
    <div class="grid grid sm:gap-y-5 md:gap-y-10 lg:gap-y-20 xl:gap-y-30 2xl:gap-y-40 grid-cols-1">
      <div class="p-10 bg-ltGrey">1</div>
      <div class="p-10 bg-ltGrey">2</div>
      <div class="p-10 bg-ltGrey">3</div>
    </div>
    <div class="grid grid-cols-2 gap-7 mt-10">
      <div class="p-10 bg-ltGrey">1</div>
      <div class="p-10 bg-ltGrey">2</div>
      <div class="p-10 bg-ltGrey">3</div>
    </div>
    <div class="grid grid-cols-3 gap-x-7 mt-10">
      <div class="p-10 bg-ltGrey">1</div>
      <div class="p-10 bg-ltGrey">2</div>
      <div class="p-10 bg-ltGrey">3</div>
    </div>
  </section>
</div>
